export const LOAD_USECASE = "LOAD_USECASE";
export const LOAD_USECASE_SUCCESS = "LOAD_USECASE_SUCCESS";
export const LOAD_USECASE_ERROR = "LOAD_USECASE_ERROR";
export const SELECT_USECASE = "SELECT_USECASE";
export const CLEAR_USECASE = "CLEAR_USECASE";
